import React, { useState } from "react";
import { Dialog, DialogContent, DialogContentText } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Status from "../../../../../request-dashboard/request/status/status";
import moment from "moment";
import "./company-dashboard-initiative-drawer-view-issue.scss";

const CompanyDashboardInitiativeDrawerViewIssue: any = (props: any) => {
  const {
    isOpenViewPopup,
    onCancel,
    options,
    issueData,
    initiativeDataPermissions,
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedItem, setSelectedItem] = useState<number | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>, item: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedItem(null);
  };

  const ITEM_HEIGHT = 48;
  return (
    <Dialog
      open={isOpenViewPopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`company-dashboard-initiative-drawer-view-issue-popup`}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        onCancel();
      }}
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="company-dashboard-initiative-drawer-view-issue">
            <div className="company-dashboard-initiative-drawer-view-issue-header">
              <div>Open Risks/Issues</div>
              <div className="company-dashboard-initiative-drawer-view-issue-header-actions"></div>
            </div>
            <div className="company-dashboard-initiative-drawer-issue-content-box">
              {issueData
                ?.filter((item: any) => item?.status === "Resolved")
                ?.map((data: any, index: number) => (
                  <div
                    key={index + 1}
                    className="company-dashboard-initiative-drawer-issue-content"
                  >
                    <div className="company-dashboard-initiative-drawer-issue-content-header-action">
                      <div className="company-dashboard-initiative-drawer-issue-content-header-action-text">
                        <div className="company-dashboard-initiative-drawer-issue-content-header-action-text-box">
                          As of: <br />
                          <span>
                            {" "}
                            {moment(data?.asOf || new Date()).format(
                              "MM-DD-YYYY",
                            )}
                          </span>
                        </div>
                        <div
                          className="company-dashboard-initiative-drawer-issue-content-header-action-text-box"
                          style={{ marginLeft: 20 }}
                        >
                          Opened By : <br />
                          <span> {data?.openedBy || "Unknown"} </span>
                        </div>
                        <div className="company-dashboard-initiative-drawer-issue-content-header-action-button-status">
                          <Status status={data?.status} />
                        </div>
                      </div>
                      <div className="company-dashboard-initiative-drawer-issue-content-header-action-button">
                        {initiativeDataPermissions && options.length > 0 && (
                          <>
                            <IconButton
                              aria-label="more"
                              id="long-button"
                              aria-controls={open ? "long-menu" : undefined}
                              aria-expanded={open ? "true" : undefined}
                              aria-haspopup="true"
                              onClick={(event) => handleClick(event, data)}
                            >
                              <i
                                className="fa fa-ellipsis-v"
                                aria-hidden="true"
                              />
                            </IconButton>
                            <Menu
                              id="long-menu"
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              slotProps={{
                                paper: {
                                  style: {
                                    maxHeight: ITEM_HEIGHT * 4.5,
                                    boxShadow:
                                      "0px 4px 12px rgba(0, 0, 0, 0.12)",
                                    borderRadius: 16,
                                    padding: 0,
                                  },
                                  sx: {
                                    "&.MuiPaper-root": {
                                      padding: "0px !important",
                                      width: "156px",
                                    },
                                  },
                                },
                                list: { "aria-labelledby": "long-button" },
                              }}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                            >
                              {options.map((option: any) => (
                                <MenuItem
                                  key={option.label}
                                  onClick={() => {
                                    option.onClick(selectedItem);
                                    handleClose();
                                  }}
                                  sx={{ padding: "8px 16px !important" }}
                                >
                                  <img src={option.icon} alt={option.label} />
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Menu>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="company-dashboard-initiative-drawer-issue-content-main">
                      <div className="company-dashboard-initiative-drawer-issue-content-main-text">
                        Description
                      </div>
                      <div className="company-dashboard-initiative-drawer-issue-content-main-sub">
                        {data?.description || "No description available"}
                      </div>
                    </div>
                    <div className="company-dashboard-initiative-drawer-issue-content-main">
                      <div className="company-dashboard-initiative-drawer-issue-content-main-text">
                        Mitigation Plan
                      </div>
                      <div className="company-dashboard-initiative-drawer-issue-content-main-sub">
                        {data?.mitigationPlan || "No Mitigation Plan available"}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
            <div className="company-dashboard-initiative-drawer-disposition-close">
              <div className="company-dashboard-initiative-drawer-disposition-close-text">
                <button
                  className="company-dashboard-initiative-drawer-disposition-close-text-button"
                  onClick={onCancel}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardInitiativeDrawerViewIssue;
